import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { lobbyPeersKeySelector } from "../../../helpers/Selectors";
import { FormattedMessage } from "react-intl";
import List from "@material-ui/core/List";
import ListSubheader from "@material-ui/core/ListSubheader";
import LobbyPeerListItem from "./LobbyPeerListItem";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import RoomContext from "../../../context/RoomContext";

const Lobby = () => {
  const useStyles = makeStyles((theme) =>
    createStyles({
      acceptAllButton: {
        marginTop: 10,
        height: 45,
        width: 50,
        float: "right",
        backgroundColor: "#ffffff ",
        "&:hover": {
          backgroundColor: "rgba(50,137,239,0.11)",
        },
      },
    })
  );

  const lobbyPeers = useSelector((state) => lobbyPeersKeySelector(state));
  const classes = useStyles();
  const { roomClient } = useContext(RoomContext);

  const handleAcceptAll = () => {
    lobbyPeers.map((peerId) => {
      roomClient.promoteLobbyPeer(peerId);
    });
  };

  return lobbyPeers.length > 0 ? (
    <List
      dense
      subheader={
        <ListSubheader component="div">
          <FormattedMessage
            id="room.peersInLobby"
            defaultMessage="Participants in Lobby"
          />
          {" (" + lobbyPeers.length + ")"}
          <Button
            variant="text"
            size="small"
            className={classes.acceptAllButton}
            onClick={handleAcceptAll}
          >
            <FormattedMessage
              id="room.acceptAllInLobby"
              defaultMessage="Accept All ParticipantS"
            />
          </Button>
        </ListSubheader>
      }
    >
      {lobbyPeers.map((peerId) => {
        return <LobbyPeerListItem key={peerId} id={peerId} />;
      })}
    </List>
  ) : null;
};

export default Lobby;
